import { ButtonGroup, Divider, HStack, Td, Text } from "@chakra-ui/react";
import { Breadcrumb, Container, Form, Heading, Icon, IconButton, Profile, Row, Searchable, Table } from "components";
import { Moment } from "config";
import { useBonusMentor } from "hooks";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function BonusMentor(){

    const [ period, setPeriod ] = useState([Moment().startOf('month').toDate(), Moment().endOf('month').toDate()])
    const list = useBonusMentor(period)

    const columns = [{ children: 'Mentor' }, { children: 'Diamante' }]

    return(
    <Container>

        <Breadcrumb prev={{ path: '/tools', label: 'Ferramentas' }} current="Bônus Mentor" />

        <Heading title="Bônus Mentor">
            <ButtonGroup size="xs" isDisabled={list.isFetching}>
                <IconButton label="Atualizar" icon="refresh" isLoading={list.isFetching} onClick={list.refetch} />
            </ButtonGroup>
        </Heading>

        <Divider my={4} />

        <Searchable>
            <Form.Interval initial={period} onSelect={setPeriod} />
        </Searchable>

        <Table columns={columns} mt={4}>
            { list.data?.map(item => <Item key={item.id} data={item} />)}
        </Table>

    </Container>
    )
}

const Item = ({ data }) => {
    
    const navigate = useNavigate()

    return(
    <Row onClick={() => navigate(`/consultants/${data.consultant_id}`)}>
        <Td><Profile name={data?.consultant_name} /></Td>
        <Td><HStack><Icon name="diamond" /><Text children={data?.diamond_name} textTransform="capitalize" /></HStack></Td>
    </Row>
    )
}